// @flow
import React from 'react';
import MenuItem from 'material-ui/MenuItem';
import { translate } from 'react-i18next';

import CampaignListing from 'common/modules/campaign/domain/CampaignListing';
import CategorizedDropdown from './CategorizedDropdown';

type Props = {
  campaigns: CampaignListing[],

  value: string,
  disabled: boolean,
  onChange: string => void,
  withNoCampaign: boolean,

  t: any,
};

const CampaignsDropdown = ({ value, disabled, onChange, t, campaigns, withNoCampaign }: Props) =>
  <CategorizedDropdown
    value={value}
    disabled={disabled}
    onChange={onChange}
    hintText={t('selectACampaign')}
    noMatchFoundText={t('noCampaignFound')}
    generateItem={item => <MenuItem key={item.reference} primaryText={item.name} value={item.reference} />}
    data={withNoCampaign ? generateCategorizedCampaignsWithNoCampaign(t, campaigns) : generateCategorizedCampaigns(campaigns)}
  />;

export function generateCategorizedCampaignsWithNoCampaign(t: any, campaigns: CampaignListing[]) {
  const categorizedCampaigns = generateCategorizedCampaigns(campaigns);
  categorizedCampaigns.undefined = [{ value: '', label: t('allCampaigns') }];
  return categorizedCampaigns;
}

export function generateCategorizedCampaigns(campaigns: CampaignListing[]) {
  const categorizedCampaigns = campaigns.reduce((acc, campaign) => {
    const category = campaign.getAdvertiserName();
    if (!(category in acc)) {
      acc[category] = [];
    }

    acc[category].push({ value: campaign.reference, label: campaign.name });
    return acc;
  }, {});
  return categorizedCampaigns;
}

export default translate('campaigns')(CampaignsDropdown);



// WEBPACK FOOTER //
// ./src/common/components/CampaignsDropdown.js